import React from 'react';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section className="w-full bg-cream px-5 py-20 text-center sm:py-24" data-id="element-93" data-mp="vfftwlftpyqe">
      <div className="mx-auto max-w-2xl" data-id="element-94" data-mp="vhajid21if0t">
        <h2 className="font-display text-[1.9rem] font-black leading-tight tracking-tight text-ink sm:text-[2.6rem]" data-id="element-95" data-mp="19f7g39ghulfh">
          Ready to Get Your <span className="italic text-brand" data-id="element-96" data-mp="15bspxpyucoob">Time Back?</span>
        </h2>
        <CtaButton data-id="element-97" data-mp="1jc3fmpoezx7w" />
        <p className="mt-5 text-[11px] font-medium text-ink/50" data-id="element-98" data-mp="1jbk882we4r84">
          Instant Download · One-Time Payment · Lifetime Access · 7-Day
          Guarantee
        </p>
      </div>
    </section>;
}